var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  classname: "svI",
  width: 13.019,
  height: 13.207,
  viewBox: "0 0 13.019 13.207"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Group_3577",
  "data-name": "Group 3577",
  transform: "translate(-961.462 -333.293)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_84",
  "data-name": "Path 84",
  d: "M-4591.471-691.587h-4.733v12h12v-4.576",
  transform: "translate(5558.167 1025.587)",
  fill: "none",
  stroke: "#ffffff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_3178",
  "data-name": "Group 3178",
  transform: "translate(967.669 334)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_85",
  "data-name": "Path 85",
  d: "M-4590.015-685.817l6.1-6.171",
  transform: "translate(4590.015 691.988)",
  fill: "none",
  stroke: "#ffffff",
  strokeLinecap: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_86",
  "data-name": "Path 86",
  d: "M-4587.394-691.587h4.055v3.868",
  transform: "translate(4589.632 691.587)",
  fill: "none",
  stroke: "#ffffff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
})))));
export default __webpack_public_path__ + "static/media/openInNewWhite.e3f782f4.svg";
export { SvgComponent as ReactComponent };